$.namespace(
  'MemePlayerTrack',
  $.Class(function (klass) {
    this.player = null;

    this.init = function (player) {
      this.player = player;
    };

    this.track = function (eventName, params) {
      params = _.assign(
        {
          type: this.player.playerType,
          room_id: this.player.roomId,
          platform: 'pc',
          cdn: this.currentLine,
        },
        params || {},
      );

      MM.log.send({
        event: 'player_track',
        event_type: eventName,
        params: params,
      });
      sa.track(eventName, params);
    };

    this.currentLine = -1;

    this.updateLine = function (videoUrl) {
      //var lines = {'ws.sumeme': 1, 'aliyun': 5, 'cs.sumeme': 8}

      if (videoUrl.indexOf('ws.sumeme') > -1) {
        this.currentLine = 1;
      } else if (videoUrl.indexOf('aliyun') > -1) {
        this.currentLine = 5;
      } else if (videoUrl.indexOf('cs.sumeme') > -1) {
        this.currentLine = 8;
      } else {
        this.currentLine = -1;
      }
    };

    this.startConnectTime = 0;
    this.startPlayTime = 0;
    this.startStuckTime = 0;

    this.startConnect = function () {
      this.startConnectTime = Date.now();
    };

    this.endConnect = function () {
      if (this.startConnectTime > 0) {
        var time = Date.now() - this.startConnectTime;
        this.track('video_connect', {
          connnectTime: time,
        });
        MM.core.debug('【player time】connectTime', time);
        // startConnectTime = 0;
      }
    };

    this.disconnect = function () {
      if (this.startPlayTime > 0) {
        // this.track('video_disconnect');
        this.startPlayTime = 0;
      }
    };

    this.startPlay = function () {
      if (this.startPlayTime > 0) {
        var time = (Date.now() - this.startConnectTime) / 1000;
        this.track('video_first_load', {
          first_load_time: time,
        });
        MM.core.debug('【player time】connectTime', time);
      }
    };

    this.startStuck = function () {
      if (this.startConnectTime > 0) {
        this.startStuckTime = Date.now();
        var sec = (Date.now() - this.startConnectTime) / 1000;
        this.track('video_stuck_ts', {
          sec: sec,
        });
        MM.core.debug('【player time】video_stuck_ts', sec);
      }
    };

    this.endStuck = function () {
      if (this.startStuckTime === 0) {
        return;
      }
      var time = Date.now() - this.startStuckTime;
      this.track('video_stuck_replay', {
        stuckTime: time,
      });
      MM.core.debug('【player time】stuckTime', time);
      this.startStuckTime = 0;
    };
  }),
);
